module.exports = __webpack_public_path__ + "media/partners/oponeo2x-e21412dc.png";